module.exports = __webpack_public_path__ + "static/media/return.3dc8d916.svg";